<template>
    <div>
        <div style="margin-top:20px">
            <img src="~assets/image/trayBank/shareProduction.png" alt />
        </div>
        <!-- 拼单 -->
        <ul class="title">
            <li>
                <h2 @click="activeTabIndex = 0 " :class="activeTabIndex == 0 ? 'activeTab' : 'tab' ">正在生产</h2>
            </li>
            <li class="line"></li>
            <li>
                <h2 @click="activeTabIndex = 1 " :class="activeTabIndex == 1 ? 'activeTab' : 'tab' ">排单生产</h2>
            </li>
        </ul>
        <ul class="shareProduct clearfix">
            <li>
                <h3>产品名称</h3>
            </li>
            <li>
                <h3>产品图片</h3>

            </li>
            <li>
                <h3>加单价格</h3>
            </li>
            <li v-if=" 0 == activeTabIndex">
                <h3>停机时间</h3>
            </li>
            <li v-if="1 == activeTabIndex">
                <h3>开机时间</h3>
            </li>
            <li>
                <h3>起订数量</h3>
            </li>
            <li>
                <h3>满额度</h3>
            </li>
            <li>
                <h3>立即加单</h3>
            </li>
        </ul>
        <div class="productList" v-for="(planList, index) in [runningPlan, scheduledPlan]" :key="index" v-if="index == activeTabIndex" >
            <div class="develop" v-if="!planList.length">
                <div class="image">
                    <img src="~assets/image/develop.png" alt="">
                </div>
                <p>现在没有{{activeTabIndex == 0 ? '正在生产中' : '排产中'}}的拼单哦~</p>
            </div>
            <div class="content" v-else v-for="plan in planList" :key="plan.planId">
                <div class="productName" @click="checkProductDetails(plan.productId)" >
                    <div>
                        <h3>{{plan.productName}}</h3>
                    </div>
                    <div>
                        <dict-box namespace="target" id="model" :value="plan.targetModelCode" />
                    </div>
                </div>
                <!-- 图片 -->
                <div class="image" @click="checkProductDetails(plan.productId)" >
                    <img :src="plan.filePath" style="width: 150px">
                </div>
                <div class="price">
                    <div>¥{{plan.groupPrice}}</div>
                    <div>¥{{plan.originalPrice}}</div>
                </div>
                <div class="time">
                    <div class="imgs">
                        <img src="~assets/image/trayBank/time.png" alt="">
                    </div>
                    <div>
                        {{plan.countDown}}
                    </div>
                </div>
                <!-- 起购数量 -->
                <div class="quantity">
                    <p>{{plan.minShareQuantity}}</p>
                </div>
                <!-- 满额 -->
                <div class="orderdQuantity">
                    <Progress :percent="100*(plan.orderedQuantity/plan.maxQuantity).toFixed(2)" style="width:150px" status="active" :stroke-width="20" stroke-color="#ff8800" text-inside />
                </div>
                <!-- 立即认购 -->
                <div class="planOrder">
                    <Button type="warning" :disabled="plan.orderedQuantity == plan.maxQuantity || plan.countDown == '00: 00: 00' " @click="onAddPromptly(plan)">立即加单</Button>
                </div>
            </div>
        </div>
        <add-plan ref="addPlanRef" @refresh="refresh"/>

    </div>
</template>

<script>

import addPlan from './componet/addPlan.vue';
export default {
    components:{addPlan},
    data() {
        return {
            activeTab: '',
            activeTabIndex: 0,
            scheduledPlan: [],
            runningPlan: [],
        }
    },
    mounted() {
        this.queryFactoryScheduler();
    },
    methods: {
        refresh(){
            this.queryFactoryScheduler()
        },
       async onAddPromptly(data){
            let sessionId = this.pltSession.getSession()
            if (!sessionId) {
                await this.showConfirm("提示", "您还未登陆, 去登陆?");
                this.$router.push('/login');
                this.$store.commit('anonymous/setPath', {to: '/share-production' });
                return;
            }
           this.$refs['addPlanRef'].openModal(data)
        },
        queryFactoryScheduler() {
            let param = {
                url: 'http://MID-CLIENT-MALL/messageService/factoryShareProductionService/queryFactoryPlan'
            }
            this.invoke(param).then(({ scheduledPlan, runningPlan }) => {
                this.scheduledPlan = scheduledPlan;
                this.runningPlan = runningPlan;

                runningPlan.forEach((item, index) => {
                    let param = [index, 'runningPlan', 'productionEndTime'];
                    this.countDown(...param);
                    setInterval(this.countDown, 1000, ...param);
                })

                scheduledPlan.forEach((item, index) => {
                    let param = [index, 'scheduledPlan', 'productionStartTime']
                    this.countDown(...param);
                    setInterval(this.countDown, 1000, ...param);
                })
            })

        },
        countDown(index, listName, timeFieldName) {
            let row = this[listName][index];

            row.countDown = this.localUtil.futureTime2Interval(row[timeFieldName]);
          
            this.$set(this[listName], index, row);
        },
        checkProductDetails(productId) {
            let routeData = this.$router.resolve({
                path: '/product-details',
                query: { productId }
            });

            window.open(routeData.href, '_blank');
        }

    }


}
</script>

<style lang="scss" scoped>
.shareBill {
    height: 600px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h3 {
        color: #666;
    }
}
.activeTab {
    color: #ff8800;
}
.tab {
    color: black;
}

// 拼单
.title {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 50px;
    > li {
        h2 {
            cursor: pointer;
        }
    }
    .line {
        // height: ;
        width: 2px;
        background: #666;
        margin: 0 10px;
    }
}
.shareProduct {
    height: 50px;
    line-height: 50px;
    margin-top: 50px;
    .shareProduct li:nth-child(0) {
        margin-left: 15px;
    }
    li {
        float: left;
        // margin-left: 100px;
    }
    li:nth-child(1){
        margin-left: 20px;
    }
    li:nth-child(2) {
        margin-left: 210px;
    }
    li:nth-child(3) {
        margin-left: 100px;
    }
    li:nth-child(4) {
        margin-left: 60px;
    }
    li:nth-child(5) {
        margin-left: 50px;
    }
    li:nth-child(6) {
        margin-left:70px;
    }
    li:last-child {
        margin-left: 105px;
    }
}
@mixin shape {
    width: 60px;
    height: 30px;
    border: 1px solid #ccc;
    text-align: center;
    line-height: 30px;
    // margin-bottom: 5px;
}
.productList {
    margin: 10px 0 100px 0;
    border: 1px solid #ccc;
    .content:last-child{
        border-bottom-color: transparent;;
    }
    .develop{
        height: 500px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-bottom: 100px;
        p{
            font-size: 16px;
            color: #888;
        }
    }
    .content {
        width: 1080px;
        margin-top: 30px;
        padding: 10px;
        display: flex;
        border-bottom: 1px solid #ccc;
        align-items: center;
        .productName {
            div:last-child {
                margin-top: 10px;
            }
            &:hover {
                cursor: pointer;
                color:#ff8800;
            }
        }
        .image {
            margin-left: 50px;
            &:hover {
                cursor: pointer;
            }
        }
        // 价格
        .price {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            margin-left: 40px;
            div:first-child {
                @include shape;
                margin-bottom: 5px;
            }
            div:last-child {
                color: #7a7a7a;
                text-decoration: line-through;
                text-decoration-color: #ff0000;
                -moz-text-decoration-color: #ff0000;
            }
        }
        .time {
            width: 100px;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-left: 50px;
            color: #959292;
            font-weight: bold;
        }
        // 起购数量
        .quantity {
            margin-left: 50px;
            > p {
                @include shape;
                
            }
        }
        .orderdQuantity{
            margin-left: 30px;
        }
        .planOrder{
            margin-left: 30px;
        }
    }
}
</style>